export const Words = ({ text, className = "" }) => (
  <span className={`words ${className}`}>
    {text.split(" ").map((w, i) => (
      <span className="w" key={`${w}-${i}`} style={{ "--i": i }}>{`${w}\u00a0`}</span>
    ))}
  </span>
);

export const Eyebrow = ({ children }) => <span className="eyebrow">{children}</span>;

export const SectionHead = ({ eyebrow, title, accent, sub, id }) => (
  <div className="section-head" data-reveal>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 id={id}>{title} {accent && <span className="grad-text">{accent}</span>}</h2>
    {sub && <p className="lead">{sub}</p>}
  </div>
);

export const NumberedCards = ({ items, testid }) => (
  <div className="num-grid" data-testid={testid}>
    {items.map(([title, desc], i) => (
      <article className="num-card spot" key={title} data-reveal style={{ "--d": `${i * 70}ms` }}>
        <span className="num">{String(i + 1).padStart(2, "0")}</span>
        <h3>{title}</h3>
        <p>{desc}</p>
      </article>
    ))}
  </div>
);
